/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Serializer for the EpaNotification model.
 * @export
 * @interface EpaNotification
 */
export interface EpaNotification {
    /**
     * 
     * @type {string}
     * @memberof EpaNotification
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof EpaNotification
     */
    notificationReportId: string;
    /**
     * 
     * @type {Date}
     * @memberof EpaNotification
     */
    detectionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof EpaNotification
     */
    notificationDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaNotification
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof EpaNotification
     */
    location: DataPointHistoryLocation;
    /**
     * Detected rate in g/hr
     * @type {number}
     * @memberof EpaNotification
     */
    detectedRate: number;
    /**
     * 
     * @type {string}
     * @memberof EpaNotification
     */
    notifierId?: string;
    /**
     * 
     * @type {string}
     * @memberof EpaNotification
     */
    notifierName?: string;
    /**
     * 
     * @type {string}
     * @memberof EpaNotification
     */
    providerName?: string;
    /**
     * 
     * @type {string}
     * @memberof EpaNotification
     */
    detectionTechnology?: string;
    /**
     * Wind speed in m/s
     * @type {number}
     * @memberof EpaNotification
     */
    windSpeed?: number | null;
    /**
     * Wind direction in degrees
     * @type {number}
     * @memberof EpaNotification
     */
    windDirection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EpaNotification
     */
    temperature?: number | null;
    /**
     * Humidity in g/kg
     * @type {number}
     * @memberof EpaNotification
     */
    humidity?: number | null;
    /**
     * 
     * @type {any}
     * @memberof EpaNotification
     */
    metadata?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaNotification
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EpaNotification
     */
    readonly updatedAt: Date | null;
}

/**
 * Check if a given object implements the EpaNotification interface.
 */
export function instanceOfEpaNotification(value: object): value is EpaNotification {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('notificationReportId' in (value as Record<string, any>)) && !('notification_report_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['notificationReportId'] === undefined && (value as Record<string, any>)['notification_report_id'] === undefined)) return false;
    if ((!('detectionDate' in (value as Record<string, any>)) && !('detection_date' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionDate'] === undefined && (value as Record<string, any>)['detection_date'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('detectedRate' in (value as Record<string, any>)) && !('detected_rate' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectedRate'] === undefined && (value as Record<string, any>)['detected_rate'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function EpaNotificationFromJSON(json: any): EpaNotification {
    return EpaNotificationFromJSONTyped(json, false);
}

export function EpaNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EpaNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'notificationReportId': json['notification_report_id'],
        'detectionDate': (new Date(json['detection_date'])),
        'notificationDate': json['notification_date'] === undefined ? undefined : json['notification_date'] === null ? null : (new Date(json['notification_date'])),
        'dueDate': json['due_date'] === undefined ? undefined : json['due_date'] === null ? null : (new Date(json['due_date'])),
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'detectedRate': json['detected_rate'],
        'notifierId': json['notifier_id'] == null ? undefined : json['notifier_id'],
        'notifierName': json['notifier_name'] == null ? undefined : json['notifier_name'],
        'providerName': json['provider_name'] == null ? undefined : json['provider_name'],
        'detectionTechnology': json['detection_technology'] == null ? undefined : json['detection_technology'],
        'windSpeed': json['wind_speed'] === undefined ? undefined : json['wind_speed'] === null ? null : json['wind_speed'],
        'windDirection': json['wind_direction'] === undefined ? undefined : json['wind_direction'] === null ? null : json['wind_direction'],
        'temperature': json['temperature'] === undefined ? undefined : json['temperature'] === null ? null : json['temperature'],
        'humidity': json['humidity'] === undefined ? undefined : json['humidity'] === null ? null : json['humidity'],
        'metadata': json['metadata'] === undefined ? undefined : json['metadata'] === null ? null : json['metadata'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function EpaNotificationToJSON(json: any): EpaNotification {
    return EpaNotificationToJSONTyped(json, false);
}

export function EpaNotificationToJSONTyped(value?: Omit<EpaNotification, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification_report_id': value['notificationReportId'],
        'detection_date': value['detectionDate'].toISOString(),
        'notification_date': value['notificationDate'] == null ? value['notificationDate'] : value['notificationDate'].toISOString(),
        'due_date': value['dueDate'] == null ? value['dueDate'] : value['dueDate'].toISOString(),
        'location': DataPointHistoryLocationToJSON(value['location']),
        'detected_rate': value['detectedRate'],
        'notifier_id': value['notifierId'],
        'notifier_name': value['notifierName'],
        'provider_name': value['providerName'],
        'detection_technology': value['detectionTechnology'],
        'wind_speed': value['windSpeed'],
        'wind_direction': value['windDirection'],
        'temperature': value['temperature'],
        'humidity': value['humidity'],
        'metadata': value['metadata'],
    };
}

